import * as React from "react";
import { useState, useEffect } from "react";
import { Icon, Intent, Menu } from "./externals";
import "./ListMenu.scss";
import { Classes } from "../style";
export const ListMenu = ({ items, itemRenderer = (item, _index) => item.toString(), onSelect = () => { }, onRemove = () => { }, selectedItem, canRemove, canSelect, canEdit, onConfirmItemEdit = () => { }, defaultItem, }) => {
    const initialValue = canSelect ? 0 : undefined;
    const selectedIndex = initialValue !== undefined
        ? items.findIndex((item) => selectedItem && itemRenderer(selectedItem) === itemRenderer(item))
        : -1;
    return (React.createElement(Menu, null, items && items.length > 0 ? (items.map((item, index) => (React.createElement(ListMenuItem, { key: index, index: index, text: itemRenderer(items[index]), selected: index === selectedIndex && canSelect === true, onClick: () => onSelect(item, index), onRemove: () => onRemove(item, index), canRemove: canRemove
            ? defaultItem
                ? itemRenderer(item) !== itemRenderer(defaultItem)
                : true
            : false, canSelect: canSelect, canEdit: canEdit
            ? defaultItem
                ? itemRenderer(item) !== itemRenderer(defaultItem)
                : true
            : false, onConfirmItemEdit: (value) => onConfirmItemEdit(value, index) })))) : (React.createElement("span", null, "No items"))));
};
const ListMenuItem = ({ text, selected, onClick, onRemove, canRemove, canSelect, onConfirmItemEdit, canEdit, index, }) => {
    const [editing, setEditing] = useState(false);
    const [itemValue, setItemValue] = useState(text);
    useEffect(() => {
        setItemValue(text);
        setEditing(false);
    }, [text, index]);
    const submitEdit = (e) => {
        e.preventDefault();
        if (onConfirmItemEdit !== undefined) {
            onConfirmItemEdit(itemValue);
        }
        setEditing(false);
    };
    return (React.createElement("li", { onClick: canSelect ? onClick : undefined, role: "menuOption", className: `${canSelect ? "removable-listmenu-item-select" : "removable-listmenu-item"} focus-actionableList${selected ? " focus-actionableList-selected" : ""}` },
        editing && onConfirmItemEdit && canEdit ? (React.createElement("form", { onSubmit: submitEdit },
            React.createElement("input", { value: itemValue, onChange: (e) => setItemValue(e.target.value), onClick: (event) => {
                    event.stopPropagation();
                } }))) : (React.createElement("span", null, text)),
        React.createElement("div", null,
            canEdit && (React.createElement(Icon, { className: "edit-icon", icon: "edit", intent: Intent.NONE, onClick: (event) => {
                    event.stopPropagation();
                    setEditing(!editing);
                } })),
            canRemove && (React.createElement(Icon, { className: Classes.DELETE_ICON, role: "optionDeleteIcon", icon: "trash", intent: Intent.NONE, onClick: (event) => {
                    event.stopPropagation();
                    if (onRemove)
                        onRemove();
                } })))));
};
//# sourceMappingURL=ListMenu.js.map